import Promise from 'bluebird';
import {
  getBrands,
  getBrandHeader,
  getBrandFooter,
  getBrandProducts
} from 'shared/models/api';

const BRAND_INDEX_LOADING = 'BRAND_INDEX_LOADING';
const BRAND_INDEX_LOADED = 'BRAND_INDEX_LOADED';
const BRAND_LOADING = 'BRAND_LOADING';
const BRAND_LOADED = 'BRAND_LOADED';

const init = {
  index: [],
  header: '',
  footer: '',
  brandname: '',
  products: [],
  loading: false,
  indexLoading: false
};

export default function(state = init, action = {}) {
  switch (action.type) {
    case BRAND_INDEX_LOADING:
      return { ...state, indexLoading: true };
    case BRAND_INDEX_LOADED:
      return { ...state, indexLoading: false, ...action.payload };
    case BRAND_LOADING:
      return { ...state, loading: true };
    case BRAND_LOADED:
      return { ...state, loading: false, ...action.payload };
    default:
      return state;
  }
}

export function loadBrandIndex() {
  return dispatch => {
    dispatch({ type: BRAND_INDEX_LOADING });
    getBrands().then(index => {
      dispatch({ type: BRAND_INDEX_LOADED, payload: { index } });
    });
  };
}

export function loadBrand(brandname) {
  return dispatch => {
    dispatch({ type: BRAND_LOADING });
    return Promise.all([
      getBrandHeader(brandname),
      getBrandFooter(brandname),
      getBrandProducts(brandname)
    ]).spread((header, footer, { products }) => {
      dispatch({
        type: BRAND_LOADED,
        payload: { header, footer, brandname, products }
      });
    });
  };
}



// WEBPACK FOOTER //
// ./shared/components/brands/actions.js